import {
  CreateNewRoom,
  GetRoomsList,
  CreateNewMessage,
  GetMessagesList,
  DeleteMessage,
  GetMessagingRoom
} from "@/api/messages";

export const createNewRoom = ({ dispatch }, data) =>
  dispatch("CheckAuth", null, { root: true }).then(() =>
    CreateNewRoom(data)
      .then(res => {
        return res;
      })
      .catch(
        e =>
          new Promise((resolve, reject) => {
            reject(e);
          })
      )
  );

export const getMessagingRoom = ({ dispatch }, params) =>
  dispatch("CheckAuth", null, { root: true }).then(() =>
    GetMessagingRoom(params)
      .then(res => {
        return res;
      })
      .catch(
        e =>
          new Promise((resolve, reject) => {
            reject(e);
          })
      )
  );

export const getRoomsList = ({ dispatch }, params) =>
  dispatch("CheckAuth", null, { root: true }).then(() =>
    GetRoomsList(params)
      .then(res => {
        return res;
      })
      .catch(
        e =>
          new Promise((resolve, reject) => {
            reject(e);
          })
      )
  );

export const createNewMessage = ({ dispatch }, data) =>
  dispatch("CheckAuth", null, { root: true }).then(() =>
    CreateNewMessage(data)
      .then(res => {
        return res;
      })
      .catch(
        e =>
          new Promise((resolve, reject) => {
            reject(e);
          })
      )
  );

export const getMessagesList = ({ dispatch }, data) =>
  dispatch("CheckAuth", null, { root: true }).then(() =>
    GetMessagesList(data)
      .then(res => {
        return res;
      })
      .catch(
        e =>
          new Promise((resolve, reject) => {
            reject(e);
          })
      )
  );

export const deleteMessage = ({ dispatch }, data) =>
  dispatch("CheckAuth", null, { root: true }).then(() =>
    DeleteMessage(data)
      .then(res => {
        return res;
      })
      .catch(
        e =>
          new Promise((resolve, reject) => {
            reject(e);
          })
      )
  );
